import { Link } from "react-router-dom";
import { categories, events } from "@/mocks/events";

export default function CategorySection() {
  const list = categories.filter((c) => c.key !== "all");

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {list.map((c) => {
        const count = events.filter((e) => e.category === c.key).length;
        return (
          <Link
            key={c.key}
            to={`/events?cat=${c.key}`}
            className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-secondary-300 hover:bg-secondary-50"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-800 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
              <i className={`${c.icon} text-2xl`}></i>
            </span>
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-base font-bold text-foreground-950">{c.name}</h3>
                <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-900">
                  {count} 条
                </span>
              </div>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
            </div>
            <i className="ri-arrow-right-line ml-auto mt-1 shrink-0 text-lg text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-secondary-600"></i>
          </Link>
        );
      })}
    </div>
  );
}